import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './SearchCars.css';
import SearchbarSection from './SearchbarSection';
import LeftSection from './LeftSection';
import RightSection from './RightSection';

const SearchIndividual = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const criteria = queryParams.get('criteria');
    const value = queryParams.get('value');

    const [cars, setCars] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(5);

    useEffect(() => {
        const fetchCars = async () => {
            try {
                const response = await axios.get(`https://skcapi.btcjapan.co/getIconCars.php?criteria=${criteria}&value=${value}`);
                console.log("API Response:", response.data); // Debugging
                if (response.data && response.data.length > 0) {
                    setCars(response.data);
                    setError(null); // Clear any previous error
                } else {
                    setError('No cars found for the selected criteria.');
                    setCars([]); // Ensure cars is empty when no results
                }
                setLoading(false);
            } catch (error) {
                console.error('Error fetching cars:', error.response ? error.response.data : error.message);
                setError('Failed to fetch cars. Please try again later.');
                setLoading(false);
            }
        };

        if (criteria && value) {
            fetchCars();
        } else {
            setError('Invalid search criteria or value.');
            setLoading(false);
        }
    }, [criteria, value]);

    const handleViewVehicle = (carId) => {
        navigate(`/vehicle-details/${carId}`);
    };

    // Calculate the current items to display
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = cars.slice(indexOfFirstItem, indexOfLastItem);

    // Change page
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    return (
        <div className="row">
            <div className="col-2 leftcol">
                <LeftSection />
            </div>
            <div className="col-8 middlecol">
                <SearchbarSection />
                <hr className="title-line" />

                <h1 style={{ textAlign: 'center', fontSize: '24px', color: '#0E3435', fontWeight: '600' }}>
                    Search Results for <span style={{ color: 'rgb(228, 160, 44)' }}>{value}</span>
                </h1>

                {loading ? (
                    <div style={{ textAlign: 'center', margin: '20px 0' }}>Loading...</div>
                ) : error ? (
                    <div style={{ textAlign: 'center', margin: '20px 0', color: 'red' }}>{error}</div>
                ) : cars.length > 0 ? (
                    <>
                        {currentItems.map((car) => (
                            <div key={car.id}>
                                <div className="row car-show">
                                    <div className="col-lg-4">
                                        <img
                                            src={`https://skcapi.btcjapan.co/${car.images}`}
                                            alt={car.model}
                                            onClick={() => handleViewVehicle(car.id)}
                                            style={{ cursor: 'pointer' }}
                                        />
                                    </div>
                                    <div className="col-lg-6">
                                        <h3>{car.maker} {car.model} {car.year}</h3>
                                        <p>Location: {car.country}</p>
                                        <h4>$ {car.price}</h4>
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th>Engine</th>
                                                    <td>{car.engine_size} CC</td>
                                                </tr>
                                                <tr>
                                                    <th>Transmission</th>
                                                    <td>{car.transmission}</td>
                                                </tr>
                                                <tr>
                                                    <th>Color</th>
                                                    <td>{car.color}</td>
                                                </tr>
                                                <tr>
                                                    <th>Fuel</th>
                                                    <td>{car.fuel}</td>
                                                </tr>
                                                <tr>
                                                    <th>Mileage</th>
                                                    <td>{car.mileage} KM</td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {/* Add more rows if needed */}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="col-lg-2">
                                        <button>Get Price Quote</button>
                                        <button onClick={() => handleViewVehicle(car.id)}>View Vehicle</button>
                                    </div>
                                </div>
                                <hr className="title-line" />
                            </div>
                        ))}
                        <div className="pagination">
                            {Array.from({ length: Math.ceil(cars.length / itemsPerPage) }, (_, i) => (
                                <button
                                    key={i + 1}
                                    onClick={() => paginate(i + 1)}
                                    className={currentPage === i + 1 ? 'active' : ''}
                                >
                                    {i + 1}
                                </button>
                            ))}
                        </div>
                    </>
                ) : null} {/* Avoid rendering anything extra if no cars and no error */}
            </div>
            <div className="col-2 rightcol">
                <RightSection />
            </div>
        </div>
    );
};

export default SearchIndividual;